import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from '../../core/services/auth/auth.service';
import { version } from '../../../../../../package.json';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  imports: [
    MatButton
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent {

  versionInfo  = `TebiTasks App v${version} - ${environment.name}`;

  authService: AuthService = inject<AuthService>(AuthService);

  login() {
    this.authService.login();
  }

}
